import { render, staticRenderFns } from "./drawerProduct.vue?vue&type=template&id=35aa7f04&"
import script from "./drawerProduct.vue?vue&type=script&lang=js&"
export * from "./drawerProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports